import { getSectionHTML } from '../utils/section-renderer';
import type ProductCarousel from './product-carousel';

export default class RecommendedProducts extends HTMLElement {
  private grid: HTMLElement | null = null;

  connectedCallback(): void {
    this.grid = this.querySelector('[data-product-carousel-ref="grid"]');

    if (!this.dataset.productId || !this.dataset.recommendationsUrl) {
      return;
    }

    this.fetchRecommendations();
  }

  private get sectionId(): string {
    const id = this.getAttribute('section-id');

    if (!id) {
      throw new Error('The section-id attribute is required on <recommended-products>');
    }

    return id;
  }

  private buildRecommendationsUrl(): URL {
    const url = new URL(this.dataset.recommendationsUrl!, window.location.origin);
    url.searchParams.set('product_id', this.dataset.productId!);
    url.searchParams.set('limit', '8');
    url.searchParams.set('intent', 'related');
    return url;
  }

  private async fetchRecommendations(): Promise<void> {
    try {
      const sectionHtml = await getSectionHTML(this.sectionId, this.buildRecommendationsUrl());
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sourceGrid = parsed.querySelector('[data-product-carousel-ref="grid"]');

      if (!sourceGrid?.innerHTML.trim() || !this.grid) {
        this.classList.add('hidden');
        return;
      }

      this.grid.innerHTML = sourceGrid.innerHTML;
      this.classList.remove('hidden');
      this.querySelector<ProductCarousel>('product-carousel')?.refresh();
    } catch (error) {
      console.error(error);

      if (!this.grid?.innerHTML.trim()) {
        this.classList.add('hidden');
      }
    }
  }
}

customElements.define('recommended-products', RecommendedProducts);
